import axios from 'axios'
const CancelToken = axios.CancelToken
const baseURL = 'https://ssd.coinpayu.com'
let cancel // eslint-disable-line no-unused-vars
let service = axios.create({
  baseURL: baseURL,
  timeout: 60000
})
// 添加请求拦截器
service.interceptors.request.use(function (config) {
  config.headers['cointoken'] = '36d4635ae108fb89322cd4bee9aef7999eca4b17'
  return config
}, function (error) {
  return Promise.reject(error)
})
// 添加响应拦截器
service.interceptors.response.use((response) => {
  return response.data
}, function (error) {
  console.log('err' + error)
  return Promise.reject(error)
})

export function get (url, params) {
  return new Promise((resolve, reject) => {
    service({
      method: 'get',
      url,
      params: params,
      cancelToken: new CancelToken(c => {
        cancel = c
      })
    }).then(res => { // axios返回的是一个promise对象
      // resolve在promise执行器内部
      if(res.code==0){
        location.href = '/';
      }else{
        resolve(res)
      }
    }).catch(err => {
      console.log(err, 'err')
    })
  })
}
export function post (url, params) {
  return new Promise((resolve, reject) => {
    service({
      method: 'post',
      url,
      data: params,
      cancelToken: new CancelToken(c => {
        cancel = c
      })
    }).then(res => {
      resolve(res)
    }).catch(err => {
      console.log(err, 'err')
    })
  })
}
export function formData (url, params) {
  let formData = new FormData()
  for (let key in params) {
    formData.append(key, params[key])
  }
  return new Promise((resolve, reject) => {
    service({
      method: 'post',
      url,
      data: formData,
      cancelToken: new CancelToken(c => {
        cancel = c
      })
    }).then(res => {
      resolve(res)
    }).catch(err => {
      console.log(err, 'err')
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/axios.js